"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verticalPaddingSizes = exports.validHeaderLabelSizes = exports.CardHeaderLabel = exports.CardHeaderContainer = exports.CardHeader = exports.CardBody = exports.Card = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _valueMap = _interopRequireDefault(require("../utils/valueMap"));
var _constants = require("../constants");
var _polished = require("polished");
var _card_table = _interopRequireDefault(require("./card_table"));
var _colors = require("../../birch/colors");
var _templateObject, _templateObject2;
var _excluded = ["label", "labelSize", "leftComponent", "style", "rightComponent", "wrapRightComponent"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var birchTheme = {
  header: {
    borderStyles: 'border-bottom: none;',
    color: _colors.FullPalette.EVERGREEN_700,
    fontSize: '20px'
  },
  container: {
    backgroundColor: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.GREY_700
  },
  body: {
    backgroundColor: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.GREY_700,
    emptyStateColor: _colors.FullPalette.GREY_700
  }
};
var validHeaderLabelSizes = exports.validHeaderLabelSizes = ['small', 'large'];
var CardHeader = exports.CardHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CardHeader, _React$Component);
  var _super = _createSuper(CardHeader);
  function CardHeader() {
    (0, _classCallCheck2["default"])(this, CardHeader);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(CardHeader, [{
    key: "renderRightComponent",
    value: function renderRightComponent() {
      var _this$props = this.props,
        rightComponent = _this$props.rightComponent,
        wrapRightComponent = _this$props.wrapRightComponent;
      if (!rightComponent) {
        return null;
      }
      if (wrapRightComponent) {
        return /*#__PURE__*/React.createElement(RightComponentWrapper, null, /*#__PURE__*/React.createElement("div", null, rightComponent));
      } else {
        return rightComponent;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // rightComponent && the wrap Property are not passed through
      var _this$props2 = this.props,
        label = _this$props2.label,
        labelSize = _this$props2.labelSize,
        leftComponent = _this$props2.leftComponent,
        style = _this$props2.style,
        rightComponent = _this$props2.rightComponent,
        wrapRightComponent = _this$props2.wrapRightComponent,
        rest = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      return /*#__PURE__*/React.createElement(CardHeaderContainer, (0, _extends2["default"])({
        style: style
      }, rest), leftComponent ? /*#__PURE__*/React.createElement("div", null, leftComponent) : /*#__PURE__*/React.createElement(CardHeaderLabel, {
        labelSize: labelSize
      }, label), this.renderRightComponent());
    }
  }]);
  return CardHeader;
}(React.Component);
(0, _defineProperty2["default"])(CardHeader, "propTypes", {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  leftComponent: _propTypes["default"].element,
  rightComponent: _propTypes["default"].element,
  wrapRightComponent: _propTypes["default"].bool,
  labelSize: _propTypes["default"].oneOf(validHeaderLabelSizes),
  style: _propTypes["default"].object,
  className: _propTypes["default"].string
});
(0, _defineProperty2["default"])(CardHeader, "defaultProps", {
  labelSize: 'large',
  wrapRightComponent: true,
  style: {}
});
var CardHeaderContainer = exports.CardHeaderContainer = _styledComponents["default"].header.withConfig({
  displayName: "card__CardHeaderContainer"
})(["border-radius:3px;border-bottom-left-radius:0;border-bottom-right-radius:0;background-color:", ";border:1px solid ", ";padding:10px ", ";position:relative;box-sizing:border-box;line-height:35px;display:flex;align-content:center;justify-content:space-between;", ""], birchTheme.container.backgroundColor, birchTheme.container.borderColor, function (props) {
  return props.cardGutter;
}, function (props) {
  return !props.keepBorderBottom && birchTheme.header.borderStyles;
});
CardHeaderContainer.displayName = 'CardHeaderContainer';
CardHeaderContainer.propTypes = {
  cardGutter: _propTypes["default"].string
};
CardHeaderContainer.defaultProps = {
  cardGutter: '24px'
};
var labelSize = (0, _valueMap["default"])(validHeaderLabelSizes, 'labelSize');
var CardHeaderLabel = exports.CardHeaderLabel = _styledComponents["default"].h3.withConfig({
  displayName: "card__CardHeaderLabel"
})(["display:inline-block;margin:0;line-height:inherit;color:", ";", " ", " ", ""], birchTheme.header.color, labelSize.small(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 14px;\n  "]))), labelSize.large(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    ", "\n  "])), birchTheme.header.fontSize, (0, _constants.fontWeight)('normal')), function (props) {
  return props.active && 'cursor: pointer;';
});
CardHeaderLabel.propTypes = {
  labelSize: _propTypes["default"].oneOf(validHeaderLabelSizes)
};
CardHeaderLabel.defaultProps = {
  labelSize: 'large'
};
var RightComponentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "card__RightComponentWrapper"
})(["float:right;line-height:inherit;"]);
RightComponentWrapper.displayName = 'RightComponentWrapper';
var bottomMarginSizes = {
  none: 0,
  "default": '2em'
};
var CardPaddingTheme = function CardPaddingTheme(props) {
  var useLegacyPadding = props.useLegacyPadding,
    children = props.children;
  var theme = {
    legacyPadding: useLegacyPadding
  };
  return /*#__PURE__*/React.createElement(_styledComponents.ThemeProvider, (0, _extends2["default"])({
    theme: theme
  }, props), children);
};
var Card = exports.Card = function Card(props) {
  var useLegacyPadding = props.useLegacyPadding;
  var cardTheme = !(useLegacyPadding === undefined || useLegacyPadding === false);
  return /*#__PURE__*/React.createElement(CardPaddingTheme, (0, _extends2["default"])({
    useLegacyPadding: cardTheme
  }, props), /*#__PURE__*/React.createElement(StyledCardWrapper, (0, _extends2["default"])({
    bottomMargin: props.bottomMargin
  }, props), props.children));
};
Card.propTypes = {
  bottomMargin: _propTypes["default"].oneOf(Object.keys(bottomMarginSizes))
};
Card.defaultProps = {
  bottomMargin: 'default'
};
Card.displayName = 'Card';
var verticalPaddingSizes = exports.verticalPaddingSizes = {
  none: 0,
  small: "0.5em",
  medium: "1em",
  large: "2em"
};
var StyledCardWrapper = _styledComponents["default"].div.withConfig({
  displayName: "card__StyledCardWrapper"
})(["margin-bottom:", ";"], function (props) {
  return bottomMarginSizes[props.bottomMargin];
});
var CardBody = exports.CardBody = _styledComponents["default"].div.withConfig({
  displayName: "card__CardBody"
})(["box-sizing:border-box;background-color:", ";border:1px solid ", ";border-top:0;border-radius:5px;border-top-left-radius:0;border-top-right-radius:0;", " ", " ", " ", " .empty-state{.header{font-weight:600;}color:", ";font-size:14px;}"], birchTheme.body.backgroundColor, birchTheme.body.borderColor, function (props) {
  return props.theme.legacyPadding && (0, _polished.padding)(verticalPaddingSizes[props.verticalCardGutter] /* top and bottom */, !props.compact && props.cardGutter /* left and right */);
}, function (props) {
  return !props.theme.legacyPadding && (0, _styledComponents.css)(["padding:24px 24px;"]);
}, function (props) {
  return !props.theme.legacyPadding && props.children.type === _card_table["default"] && (0, _styledComponents.css)(["padding:0 24px 24px;"]);
}, (0, _polished.clearFix)(), _constants.colors.darkGrey);
CardBody.propTypes = {
  verticalCardGutter: _propTypes["default"].oneOf(Object.keys(verticalPaddingSizes)),
  compact: _propTypes["default"].bool,
  cardGutter: _propTypes["default"].string
};
CardBody.defaultProps = {
  verticalCardGutter: 'large',
  compact: false,
  cardGutter: '20px'
};
CardBody.displayName = 'CardBody';